import CryptoJS from 'crypto-js';

/**
 * 使用SHA512对密码进行加密
 * @param password 原始密码
 * @returns 加密后的密码（十六进制字符串）
 */
export function sha512Encrypt(password: string): string {
  return CryptoJS.SHA512(password).toString(CryptoJS.enc.Hex);
}